export class workerAddressDetails {
    action: string;
    id: number;
    username: string
    userid: string
    designation: string
    streetAddress: string
    city: string
    pincode: string
    state: string
    loggedInUser: string;
}
export class State
{
    state:string;
}